import {gql} from '@apollo/client'

export const GET_ALL_CLIENTS = gql`
  query clientList($after: String, $id: Float, $name: String, $nit: String, $offset: Int) {
    clientList(after: $after, id: $id, name_Iexact: $name, nit: $nit, offset: $offset) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
        node {
          id
          name
          nit
          phoneNumber
          address
          postpaidSales

          clientproductpriceSet {
            edges {
              node {
                id
                price
                product {
                  id
                  name
                  unitType
                  unitPrice
                }
              }
            }
          }
        }
      }
    }
  }
`
